<template lang="pug">
  textarea-autosize.scroll(
    :value="value"
    :readonly="readonly"
    :placeholder="readonly ? null : placeholder"
    v-bind="$attrs"
    rows=1
    v-on="$listeners"
  ).cc-input
</template>

<script>

export default {
  props: {
    value: { type: String, default: null },
    readonly: { type: Boolean, default: false },
    placeholder: { type: String, default: null },
  },
};
</script>

<style lang="scss" scoped>
.cc-input {
  width: 100%;
  transition: all .5s;
  // margin: -10px;
  // padding: 10px;
  border-radius: 8px;
  resize: none;

  &:hover {
    background: rgba(0,0,0, .1);
  }
  &:focus {
    outline: none;
    background: rgba(0,0,0, .1);
    box-shadow: inset 0px 0px 0px 1px $secondary-color;
  }
  &:read-only {
    background: none;
    box-shadow: none;
  }
}
</style>
